
import IDateRange from "@/../types/custom";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net";
import "datatables.net-buttons";
import { Component, Vue } from "vue-property-decorator";
import vSelect from "vue-select";
import CommissionAttendantsGraphic from "@/components/CommissionAttendantsGraphic.vue";
import ReportService from "../services/reportService";
import DateRangePicker from "vue2-daterange-picker";

@Component({
  components: {
    LayoutDefault,
    DateRangePicker,
    CommissionAttendantsGraphic,
    vSelect,
  },
})
export default class CostReport extends Vue {
  private costValues;
  private showGrid: boolean = true;
  private loadingMetric = false;
  private realType = false;

  private dateRange: IDateRange = {
    startDate: "",
    endDate: "",
  };

  private limitDateSale  = this.$moment().format('YYYY-MM-DD HH:mm:ss');
  private async created() {
    this.dateRange.startDate = this.$moment().startOf('month').format('YYYY-MM-DD'),
    this.dateRange.endDate = this.$moment().endOf('month').format('YYYY-MM-DD')
  }

  private openFilter() {
    this.$bvModal.show("modal-filter");
  }

  private async sendFilter() {
    this.loadingMetric = !this.loadingMetric;
    this.$bvModal.hide("modal-filter");
  }

  private dateFormat() {
    let result = "Filtro por data";
    if (this.dateRange.startDate) {
      result = String(
        (this.$moment(this.dateRange.startDate) as any).format("DD/MM/YYYY")
      );
      this.dateRange.endDate = this.dateRange.endDate ? this.dateRange.endDate : this.dateRange.startDate;
      result +=
        " - " +
        String((this.$moment(this.dateRange.endDate) as any).format("DD/MM/YYYY"));
    }
    return result;
  }
}
